import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ToasterService } from 'src/app/_services/toaster.service';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { NgbModal, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CourseService, EventService } from 'src/app/_services/generatedServices';
import { CreateReviewViewModel, CourseViewModel, CEUEventSummary } from 'src/app/_models/generatedModels';

@Component({
  selector: 'bxl-write-review-modal',
  templateUrl: 'write-review-modal.component.html',
})
export class WriteReviewModalComponent implements OnInit {
  initialized = false;
  rating: number = 0;
  courseEventId: number;
  public formGroup: FormGroup;

  @Input() courseEvent: CEUEventSummary;
  submitComplete: Promise<{}> | undefined;
  errorMessage: string;
  constructor(private toastr: ToasterService, public auth: AuthenticationService, private modalService: NgbModal, public activeModal: NgbActiveModal, private eventService: EventService, private courseService: CourseService, private fb: FormBuilder) {}

  ngOnInit(): void {
    this.setupForm();
  }

  setupForm(): any {
    this.formGroup = this.fb.group({
      rating: [null, [Validators.required]],
      text: ['', [Validators.required]],
    });

    this.initialized = true;
  }

  public onSave() {
    this.errorMessage = '';
    if (!this.formGroup.valid) {
      this.formGroup.markAllControlsDirty();
      this.errorMessage = 'Please fill out all required fields';
      return;
    }

    this.submitComplete = new Promise((resetButton: any, reject) => {
      const formData: CreateReviewViewModel = Object.assign({}, null, this.formGroup.value);

      this.eventService.addCEUScanReview(this.courseEventId, formData).subscribe(
        (review) => {
          this.activeModal.dismiss(review);
          this.toastr.success('Review Saved', 'Success');
          resetButton();
        },
        (error) => {
          this.errorMessage = error.error[0];
          resetButton();
        }
      );
    });
  }
}
